// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c163211","810":"445c2eb3"}[chunkId] + ".chunk.js";
};